class ReviewsSliderComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.reviews-slider__track');
    this.prevBtn = this.querySelector('.reviews-slider__btn--prev');
    this.nextBtn = this.querySelector('.reviews-slider__btn--next');

    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.slide(-1));
    this.nextBtn?.addEventListener('click', () => this.slide(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    this.updateButtons();
  }

  slide(dir) {
    const item = this.track.querySelector('.reviews-slider__item');
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }
}

customElements.define('reviews-slider-component', ReviewsSliderComponent);
